import { useSelector } from 'hooks/utils';
import { selectGroupByName } from 'store/data/variables';

export function useGroupByName(groupName: string | null, options?: { initial?: boolean }) {
	const { initial = false } = options ?? {};

	return useSelector(state => selectGroupByName(state.data.variables, { groupName, initial }));
}
